'use client'

import {
  PassportVerificationButton,
  type PassportVerificationButtonProps,
} from '@/features/verify-identity'
import { Notice } from '@/shared/ui'

export const PassportVerification = ({
  isVerified,
}: PassportVerificationButtonProps) => {
  return (
    <section>
      {!isVerified && (
        <div className="mb-6">
          <Notice.Title className="mb-3 justify-center">
            한국 휴대폰 번호가 없으신가요?
          </Notice.Title>
          <p className="typo-label1-reading text-gray-500">
            여권 본인인증은 관리자 심사 후 승인됩니다.
            <br />
            심사에는 최대 1일이 소요됩니다.
          </p>
        </div>
      )}
      <PassportVerificationButton isVerified={isVerified} />
    </section>
  )
}
